import { isAbort, loadAchievements } from '../data';
import { t } from '../i18n';
import type { Achievement } from '../types';
import { $, emptyState, errorState, h, loadingState } from '../ui/dom';
import { achievementRow } from '../ui/cards';

let controller: AbortController | null = null;
let sortDesc = true;

export async function mountAchievements(): Promise<void> {
  controller?.abort();
  controller = new AbortController();
  const signal = controller.signal;
  const list = $('ach-list');
  const sortBox = $('ach-sort');
  const count = $('ach-count');
  if (!list || !sortBox) return;

  let items: Achievement[] = [];

  const draw = (): void => {
    sortBox.replaceChildren(
      ...[true, false].map((desc) =>
        h(
          'button',
          {
            class: `chip${sortDesc === desc ? ' active' : ''}`,
            attrs: { type: 'button', 'aria-pressed': sortDesc === desc },
            text: desc ? t('common.newest') : t('common.oldest'),
            on: {
              click: () => {
                sortDesc = desc;
                draw();
              },
            },
          },
        ),
      ),
    );
    if (!items.length) {
      list.replaceChildren(emptyState());
      return;
    }
    const sorted = [...items].sort((a, b) => (sortDesc ? 1 : -1) * b.event_date.localeCompare(a.event_date));

    // Group by year for the archive look.
    const nodes: HTMLElement[] = [];
    let year = '';
    for (const a of sorted) {
      const y = a.event_date.slice(0, 4);
      if (y !== year) {
        year = y;
        nodes.push(h('div', 'tl-year', h('span', 'mono', y)));
      }
      nodes.push(achievementRow(a));
    }
    list.replaceChildren(...nodes);
  };

  draw();
  list.replaceChildren(loadingState());
  try {
    items = await loadAchievements(signal);
    if (signal.aborted) return;
    if (count) count.textContent = `${items.length} ${t('common.records')}`;
    draw();
  } catch (err) {
    if (!isAbort(err)) list.replaceChildren(errorState(() => void mountAchievements()));
  }
}

export function unmountAchievements(): void {
  controller?.abort();
  controller = null;
}
